export enum ProductsActionTypes {
    SET_PRODUCTS = 'products/setProducts',
    SET_CHILD_PRODUCTS = 'products/setChildProducts',
    LOADING_PRODUCTS = 'products/loadingProducts',
    LOADING_CHILD_PRODUCTS = 'products/loadingChildProducts',
    FILTER_PRODUCTS_BY_VALUE = 'products/filterProductsByValue',
    SORT_PRODUCTS_BY_VALUE = 'products/sortProductsByValue',
}